import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS MATERIAL UI
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'

// COMPONENTS
import Row from '../components/profile/Row'
import LogoData from '../components/app-logo/logo-data'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import CustomizeAll from '../components/сustomize-all/'
import AcceptTerm from '../components/accept-term/'
import Payment from '../components/payment'
import AddPaymentCard from '../components/payment/AddPaymentCard'
import ProfileSettings from '../components/profile/ProfileSettings'
import TraficLight from '../components/traficLight'
import { ButtonContained } from '../components/app-button/button'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'
import Promocode from '../components/promocode/'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  logo_inner: {
    width: 40,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  description_bottom: {
    width: '100%',
  },
  logo_top: {
    width: '100%',
  },
  toolbarInner: {
    padding: 0,
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  continueSystemBtn: {
    marginRight: 20,
    width: 315,
    height: 41,
    fontSize: 15,
    lineHeight: 1,
    fontWeight: 600,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  btnGroup: {
    width: '100%',
    textAlign: 'right',
  },
  column: {
    position: 'relative',
    overflow: 'hidden',
    padding: 2,
  },
})

class Profile extends Component {
  state = {
    user: window.state.user,
    message: '',
    isFetching: false,
    site: window.state.site,
  }

  handleEmailResend = () => {
    this.setState({
      isFetching: true,
      open: false,
    })

    const url = '/email/resend'

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    const json = response => {
      return response.json()
    }

    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })
      .then(status)
      .then(json)
      .then(() => {
        this.setState({
          isFetching: false,
          open: true,
          message: 'Письмо отправлено',
        })
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
      open: false,
    })

    const url = '/profile/update'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })
      .then(status)
      .then(json)
      .then(data => {
        this.setState({
          isFetching: false,
          open: true,
          message: 'Настройки сохранены',
        })
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    this.setState({ open: false })
  }

  render() {
    const { classes } = this.props
    const { user, site, message, isFetching } = this.state
    user.agree_with_offer = true;
    const setting = (
      <ProfileSettings
        load={isFetching}
        emailResend={this.handleEmailResend}
        onSubmit={this.handleSubmit}
      />
    )

    const PaymentUsers = () => {
      if (user.wizard_finished_at) {
        return user.agree_with_offer ? <Payment /> : <AddPaymentCard />
      } else {
        return null
      }
    }

    const Project = () => (
      <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
        <div className={classes.siteIcon}>S</div>
        <ul className={classes.info}>
          <Typography component="li" variant="body1">
            {site.url}
          </Typography>
          <Typography component="li" variant="overline">
            {site.name}
          </Typography>
        </ul>
      </a>
    )
    const menu = <LeftNavigationDashboard />
    const content = (
      <div className={classes.wizardContent}>
        <Row
          left={setting}
          right={
            <Fragment>
              <Promocode />
              <PaymentUsers />
            </Fragment>
          }
        />
      </div>
    )

    return (
      <Fragment>
        {user.wizard_finished_at && (
          <LicenseExpired>
            <ActionsForUsing />
          </LicenseExpired>
        )}

        <div className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px 0' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />
              {user.wizard_finished_at && (
                <Fragment>
                  <Project />
                  <TraficLight />
                </Fragment>
              )}

              <div className={classes.btnGroup}>
                {!user.wizard_finished_at && (
                  <a href="/wizard">
                    <ButtonContained
                      customClass={classes.continueSystemBtn}
                      type="button"
                      color="primary"
                      text="Продолжить настройку системы"
                    />
                  </a>
                )}
              </div>
            </Toolbar>
          </AppBar>

          {!user.agree_with_offer_date && <AcceptTerm />}

          <CustomizeAll />

          <Row left={menu} right={content} />

          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={this.state.open}
            autoHideDuration={6000}
            onClose={this.handleClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{message}</span>}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={this.handleClose}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(Profile)
